import { GetBlogsHandlerParameter } from "@eisinc/App/Handlers/Data/Blogs/LoadBlogs";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface BlogModel {
    urlSegment?: string;
    image?: string;
    summary?: string;
    title?: string;
}

type BlogsState = Readonly<{
    blogs: any;
    isLoading?: boolean;
}>;

const initialHeaderState: BlogsState = {
    blogs: {},
    isLoading: false,
};

const reducer = {
    "Blog/BeginLoadBlogs": (draft: Draft<BlogsState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "Blog/CompletedLoadBlogs": (
        draft: Draft<BlogsState>,
        action: { isLoading: boolean; blogs: BlogModel[]; parameter: GetBlogsHandlerParameter },
    ) => {
        draft.isLoading = action.isLoading;
        draft.blogs[action.parameter as any] = action.blogs;
    },
};

const blogs = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).blogs = blogs;

export type xBlogsState = {
    blogs: BlogsState;
};

type BlogsReducers = {
    isLoading: typeof blogs;
    blogs: typeof blogs;
};

export type BlogsActions = Parameters<BlogsReducers[keyof BlogsReducers]>[1] | AnyAction;
